import { Providers } from "./providers";
import { Routes } from "./routes";

export function App() {
  return (
    <Providers>
      <Routes />
    </Providers>
  );
}
